var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModalCrear",
        {
          attrs: { titulo: "Crear Dispositivo" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("NavegacionModalCrud", {
            attrs: { pasos: _vm.pasos },
            on: { guardar: _vm.handleGuardar },
            model: {
              value: _vm.pasoActivoIndex,
              callback: function($$v) {
                _vm.pasoActivoIndex = $$v
              },
              expression: "pasoActivoIndex"
            }
          })
        ],
        1
      ),
      _c(
        "v-stepper",
        {
          model: {
            value: _vm.pasoActivoIndex,
            callback: function($$v) {
              _vm.pasoActivoIndex = $$v
            },
            expression: "pasoActivoIndex"
          }
        },
        [
          _c("CrudStepperHeader", {
            attrs: {
              pasos: _vm.pasos,
              "paso-activo-index": _vm.pasoActivoIndex
            }
          }),
          _c(
            "CrudStepperItems",
            [
              _c(
                "CrudStepperContent",
                { attrs: { paso: _vm.pasos.informacionGeneral } },
                [
                  _c("DispositivoForm", {
                    attrs: { "test-id": "CrearDispositivoModal" },
                    on: {
                      change: _vm.handleFormChange,
                      estadoSwitch: _vm.handleSwitch
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.crear.titulo", {
            entidad: "Dispositivo"
          }),
          mensaje: _vm.mensajeConfirmacionInactivo,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar"),
          "test-id": "CrearDispositivo"
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.handleConfirmacionGuardar($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }